export default __webpack_public_path__ + "static/media/bstripes.8ce85682.jpg";